import angular from "angular";
import { DOMService } from "../Common/DOMService";

const OpenModalDirective = function ($rootScope, DOM: DOMService) {
    return {
        restrict: "A",
        scope: {
            modalId: "@openModal",
            withValue: "=",
            fixed: '@?',
            copy: '@?',
            modalType: "@"
        },
        link: function (scope, element, attrs) {
            element.on("click", function (e) {

                e.preventDefault();
                e.stopPropagation();

                var dismissible = angular.isUndefined(scope.fixed);
                var shouldCopy = angular.isDefined(scope.copy) && scope.copy;

                if (!scope.modalType)
                    throw "Modal type is required!";
                if (!scope.modalId)
                    throw "Modal Id is required!";

                var modalValue = scope.withValue;

                if (shouldCopy)
                    modalValue = angular.copy(modalValue);

                // As this element click event handler is executing outside of the AngularJS,
                // scope.$apply must be invoked.  This will trigger an angular digest cycle
                // after the broadcasted event is handled. Failure to trigger a digest cycle
                // would prevent model changes (made in response to the broadcasted event)
                // from being observed.
                $rootScope.$apply($rootScope.$broadcast("{0}DataChange".format(scope.modalType), modalValue));

                DOM.openModal("#" + scope.modalId, dismissible, function () {
                    // As this onClosed event handler is executing outside of the AngularJS,
                    // scope.$apply must be invoked around the event broadcast.
                    $rootScope.$apply($rootScope.$broadcast("ModalClosed", scope.modalType));
                });
            });
        }
    };
};

OpenModalDirective.$inject = ["$rootScope", "DOM"];

export { OpenModalDirective };